// V1-COMPAT: the name react18_component/react18_mount.js mount as "V1MediaOutletShow" -- the copied
// V2 MediaOutletTopLevelShow (media_outlets/media_outlet_top_level_show.jsx) wrapped with the
// entity-resolution glue (with_v2_entity.jsx) and the V2 identity glue (with_v2_identity.jsx), so a
// signed-in V1 viewer gets the same identity-gated features V2 hosts itself. Mounted by
// Frontend::PublicationsController#show once it resolves the :v2 render.
//
// Resolves through `merged_migrate_ids` rather than `migrate_id`, so this is a containment match
// rather than an equality one. V2 deduplicates publications by domain, so several V1 publications
// can share one outlet while `migrate_id` names only the canonical one; the array holds every V1
// publication id that resolves to the outlet, canonical included, so one predicate covers both
// cases. See qwoted-rails v1_link/app/postgrest_api/v1_link/apis/000_media_outlets_api.sql.erb.
import withV2Identity from './with_v2_identity';
import withV2Entity from './with_v2_entity';
import MediaOutletTopLevelShow from '../media_outlets/media_outlet_top_level_show';

// blockUntilSettled/normalizeViewerContextOnFailure: true -- see with_v2_identity.jsx's module
// comment. This show page already blocks on its own entity resolution, so withholding the mount
// until identity has settled too costs nothing extra; normalizing viewerContext on a settled
// failure keeps a signed-in viewer from ever seeing a page that mixes an authenticated
// viewerContext with cleared identity globals.
const V1MediaOutletShow = withV2Identity(withV2Entity(MediaOutletTopLevelShow, {
  apiTable: 'media_outlets',
  idColumn: 'merged_migrate_ids',
  idMatch: 'contains',
  idPropName: 'mediaOutletId',
}), { blockUntilSettled: true, normalizeViewerContextOnFailure: true });

export default V1MediaOutletShow;
